export default __webpack_public_path__ + "static/media/Workshop_18A4761-min.1a765469.jpg";